<mat-tab-group animationDuration="0ms">
    <mat-tab label="Grading Schedule">
        <app-registrar-admin-maintenance-schedule></app-registrar-admin-maintenance-schedule>
    </mat-tab>
    <mat-tab label="Faculty Category">
        <ng-template matTabContent>
            <app-registrar-admin-maintenance-faculty-category></app-registrar-admin-maintenance-faculty-category>
        </ng-template>
    </mat-tab>
    <mat-tab label="Faculty Staff Type">
        <ng-template matTabContent>
            <app-registrar-admin-maintenance-faculty-staff-type></app-registrar-admin-maintenance-faculty-staff-type>
        </ng-template>
    </mat-tab>
    <mat-tab  *ngIf="['development','test'].indexOf(health.currentHealthData.environment) >= 0" label="Grad Change Code Map">
        <app-registrar-admin-maintenance-grade-change-code-map></app-registrar-admin-maintenance-grade-change-code-map>
    </mat-tab>
    <mat-tab label="Grading Rule">
        <ng-template matTabContent>
            <app-grading-rules></app-grading-rules>
        </ng-template>
    </mat-tab>
    <mat-tab *ngIf="mayEditTextComponents" label="UI Text">
        <ng-template matTabContent>
            <app-text-list [formConfigurationAlias]="'igrade'" [enableAddButton]="false"></app-text-list>
        </ng-template>
    </mat-tab>
</mat-tab-group>
